module.exports = __webpack_public_path__ + "static/media/Norfolk-Narrow.c6477dbf.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Norfolk-Narrow.otf
// module id = 2360
// module chunks = 50